<div class="feedback-details-audit-trail">
	<div class="feedback-details-header">
		<span class="feedback-details-title">Feedback details</span>
	</div>
	<div class="loading-state" *ngIf="isLoading">Loading feedback details...</div>
	<div class="error-state" *ngIf="errorMessage">{{ errorMessage }}</div>
	<owc-table class="feedback-details-table" *ngIf="!isLoading && !errorMessage && dataSource.length; else noFeedbackDetails">
		<owc-table-header sticky>
			<owc-table-header-cell>Account ID</owc-table-header-cell>
			<owc-table-header-cell>Account Name</owc-table-header-cell>
			<owc-table-header-cell>Status</owc-table-header-cell>
			<owc-table-header-cell>LSO Acknowledgement</owc-table-header-cell>
			<owc-table-header-cell>Comments</owc-table-header-cell>
			<owc-table-header-cell>Submitter</owc-table-header-cell>
			<owc-table-header-cell>Questions and Answers</owc-table-header-cell>
		</owc-table-header>

		<owc-table-body>
			<ng-container *ngFor="let row of dataSource">
			<owc-table-row>
				<owc-table-simple-cell class="cell-value">{{ row.AccountId }}</owc-table-simple-cell>
				<owc-table-simple-cell class="cell-value">{{ row.AccountName }}</owc-table-simple-cell>
				<owc-table-simple-cell class="cell-value">{{ row.Status }}</owc-table-simple-cell>
				<owc-table-simple-cell class="cell-value">{{ row.IsLsoAcknowledged }}</owc-table-simple-cell>
				<owc-table-simple-cell class="long-value">{{ row.CustomerAttachment }}</owc-table-simple-cell>
				<owc-table-simple-cell class="long-value">{{ row.Submitter }}</owc-table-simple-cell>
				<owc-table-simple-cell
					class="cell-value"
					(click)="hasFeedbackDetails(row) && expandToggle(row)"
					[ngStyle]="{ 'pointer-events': hasFeedbackDetails(row) ? 'all' : 'none', 'cursor': hasFeedbackDetails(row) ? 'pointer' : 'default' }">
					<div class="expand-cell">
						<span>{{ hasFeedbackDetails(row) ? 'View feedback' : '-' }}</span>
						<owc-icon *ngIf="hasFeedbackDetails(row)" [name]="expandedElement === row ? 'chevron_up' : 'chevron_down'" family="outlined"></owc-icon>
					</div>
				</owc-table-simple-cell>
			</owc-table-row>
			<owc-table-row *ngIf="expandedElement === row" class="feedback-detail-row">
				<owc-table-simple-cell class="feedback-detail-cell" colspan="7">
					<div class="feedback-detail-list">
						<div class="feedback-detail-content" *ngFor="let question of row.QuestionsAndAnswers; let questionIndex = index">
							<div class="feedback-detail-title">Feedback {{ questionIndex + 1 }}</div>
							<div class="feedback-detail-field">
								<span class="feedback-detail-label">Question</span>
								<span class="feedback-detail-value">{{ question.FeedbackQuestion || '-' }}</span>
							</div>
							<div class="feedback-detail-field">
								<span class="feedback-detail-label">Answer</span>
								<span class="feedback-detail-value">{{ question.FeedbackAnswer || '-' }}</span>
							</div>
						</div>
					</div>
				</owc-table-simple-cell>
			</owc-table-row>
			</ng-container>
		</owc-table-body>
	</owc-table>

	<ng-template #noFeedbackDetails>
		<p class="empty-state" *ngIf="!isLoading && !errorMessage">No feedback details available.</p>
	</ng-template>
	<div class="btn">
		<owc-button (click)="close()">Close</owc-button>
	</div>
</div>
